import {
  getCompanyUserUpdateRecord, updateCompanyUserRecordState, getCompanyUser, addCompanyUser, updateCompanyUser,
  deleteCompanyUser, getCompanyCrm, addCompanyCrm,
  updateCompanyCrm, getCompanyContactDetail, addCompanyContactDetail,
  updateCompanyContactDetail, getCompanyUserProfile, updateCompanyUserProfile,
  getUserMemberRequest, getMembershipList, getUserLoginInfo, getUserLoginGroupInfo,
  getCompanyProfile, addCompanyProfile, updateCompanyProfile,
  getCompanyBaseInfo, addCompanyBaseInfo, updateCompanyBaseInfo,
  getCompanyMemberInfo, addCompanyMemberInfo, updateCompanyMemberInfo,
  getCompanyMemberInfoDetail, deleteCompanyProfile, deleteCompanyMemberInfo,
  getUserInfoByID, getCrmList, getCompanyContact, exportBtcMembership,
  getNextContactInfo, addNextContactInfo, getCompanyUserByContactTime,
  updateNextContactInfo, updateContactMark, getLoginInfoByIp, getLoginInfoByID, updateUserActivity, getMembershipNew,
  getCircleTourist, getCircleMember, UpdateCompanyUserFollowUpState, getCompanyPrivacy, deleteCompanyPrivacy, getSystemUser, setSalesMan, getCompanySalesUser,
  updateUserDeleteState, updatePriceDataOpinionContactDetail, addPriceDataOpinionContactDetail
} from '@/api/company'

const company = {
  state: {
    total: 0,
    rows: [],
    row: {},
    grouprows: [],
    crm: {},
    dicts: {}
  },
  mutations: {
    SET_TOTAL: (state, total) => {
      state.total = total
    },
    SET_ROWS: (state, rows) => {
      state.rows = rows
    },
    SET_ROW: (state, row) => {
      state.row = row
    },
    SET_GROUPROWS: (state, grouprows) => {
      state.grouprows = grouprows
    },
    SET_CRM: (state, crm) => {
      state.crm = crm
    },
    SET_DICTS: (state, dicts) => {
      state.dicts = dicts
    }
  },
  actions: {
    // 获取用户修改记录
    GetCompanyUserUpdateRecord({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCompanyUserUpdateRecord(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Records)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 更改修改记录状态
    UpdateCompanyUserRecordState({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateCompanyUserRecordState(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetCompanyUser({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCompanyUser(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 添加用户信息
    AddCompanyUser({ commit }, params) {
      return new Promise((resolve, reject) => {
        addCompanyUser(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 更新用户信息
    UpdateCompanyUser({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateCompanyUser(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除用户信息
    DeleteCompanyUser({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteCompanyUser(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取CRM
    GetCompanyCrm({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCompanyCrm(params).then(response => {
          commit('SET_CRM', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 添加CRM
    AddCompanyCrm({ commit }, params) {
      return new Promise((resolve, reject) => {
        addCompanyCrm(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改CRM
    UpdateCompanyCrm({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateCompanyCrm(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取联系人详情
    GetCompanyContactDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCompanyContactDetail(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 添加联系人详情
    AddCompanyContactDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        addCompanyContactDetail(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 异议CRM
    AddPriceDataOpinionContactDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        addPriceDataOpinionContactDetail(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    UpdatePriceDataOpinionContactDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        updatePriceDataOpinionContactDetail(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改联系人详情
    UpdateCompanyContactDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateCompanyContactDetail(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户权限
    GetCompanyUserProfile({ commit }, userID) {
      return new Promise((resolve, reject) => {
        getCompanyUserProfile(userID).then(response => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改用户权限
    UpdateCompanyUserProfile({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateCompanyUserProfile(params).then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询会员申请列表
    GetUserMemberRequest({ commit }, params) {
      return new Promise((resolve, reject) => {
        getUserMemberRequest(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_DICTS', response.Data.Dict)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询会员列表
    GetMembershipList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getMembershipList(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询登录信息
    GetUserLoginInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        getUserLoginInfo(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询登录分组信息
    GetUserLoginGroupInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        getUserLoginGroupInfo(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_GROUPROWS', response.Data.GroupRows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询公司信息（BTC Membership）
    GetCompanyProfile({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCompanyProfile(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 新增公司信息（BTC Membership）
    AddCompanyProfile({ commit }, params) {
      return new Promise((resolve, reject) => {
        addCompanyProfile(params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改公司信息（BTC Membership）
    UpdateCompanyProfile({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateCompanyProfile(params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询公司信息详情（BTC Membership）
    GetCompanyBaseInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCompanyBaseInfo(params).then(response => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 新增公司信息详情（BTC Membership）
    AddCompanyBaseInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        addCompanyBaseInfo(params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改公司信息详情（BTC Membership）
    UpdateCompanyBaseInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateCompanyBaseInfo(params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询会员信息（BTC Membership）
    GetCompanyMemberInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCompanyMemberInfo(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 新增会员信息（BTC Membership）
    AddCompanyMemberInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        addCompanyMemberInfo(params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 修改会员信息（BTC Membership）
    UpdateCompanyMemberInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateCompanyMemberInfo(params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateCompanyUserFollowUpState({ commit }, params) {
      return new Promise((resolve, reject) => {
        UpdateCompanyUserFollowUpState(params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateUserDeleteState({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateUserDeleteState(params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询会员详情（BTC Membership）  UpdateUserDeleteState
    GetCompanyMemberInfoDetail({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCompanyMemberInfoDetail(params).then(response => {
          commit('SET_ROW', response.Data.Row)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除公司信息（BTC Membership）
    DeleteCompanyProfile({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteCompanyProfile(params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    DeleteCompanyMemberInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteCompanyMemberInfo(params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetUserInfoByID({ commit }, companyid) {
      return new Promise((resolve, reject) => {
        getUserInfoByID(companyid).then(response => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetCrmList({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCrmList(params).then(response => {
          commit('SET_ROWS', response.Data.Row)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetCompanyContact({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCompanyContact(params).then(response => {
          commit('SET_ROW', response.Data.Row)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    ExportBtcMembership({ commit }, country) {
      return new Promise((resolve, reject) => {
        exportBtcMembership(country).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetNextContactInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        getNextContactInfo(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    AddNextContactInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        addNextContactInfo(params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateNextContactInfo({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateNextContactInfo(params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetCompanyUserByContactTime({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCompanyUserByContactTime(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateContactMark({ commit }, params) {
      return new Promise((resolve, reject) => {
        updateContactMark(params).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetLoginInfoByIp({ commit }, params) {
      return new Promise((resolve, reject) => {
        getLoginInfoByIp(params).then(response => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetLoginInfoByID({ commit }, params) {
      return new Promise((resolve, reject) => {
        getLoginInfoByID(params).then((response) => {
          commit('SET_ROWS', response.Data.Rows)
          commit('SET_TOTAL', response.Data.Total)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    UpdateUserActivity({ commit }, UserID) {
      return new Promise((resolve, reject) => {
        updateUserActivity(UserID).then((response) => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询具有权限的人员(_btcdata _beefpriceindex _beefmarketanalysis _btcreport)
    GetMembershipNew({ commit }, params) {
      return new Promise((resolve, reject) => {
        getMembershipNew(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询游客进入圈分组信息
    GetCircleTourist({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCircleTourist(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_GROUPROWS', response.Data.GroupRows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询注册用户进入圈信息
    GetCircleMember({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCircleMember(params).then(response => {
          resolve(response.Data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 查询用户修改权限记录
    GetCompanyPrivacy({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCompanyPrivacy(params).then(response => {
          resolve(response.Data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除用户修改权限记录
    DeleteCompanyPrivacy({ commit }, params) {
      return new Promise((resolve, reject) => {
        deleteCompanyPrivacy(params).then(response => {
          resolve(response.Data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    SetSalesMan({ commit }, params) {
      return new Promise((resolve, reject) => {
        setSalesMan(params).then(response => {
          resolve(response.Data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取后台用户   getCompanySalesUser
    GetSystemUser({ commit }) {
      return new Promise((resolve, reject) => {
        getSystemUser().then(response => {
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    GetCompanySalesUser({ commit }, params) {
      return new Promise((resolve, reject) => {
        getCompanySalesUser(params).then(response => {
          commit('SET_TOTAL', response.Data.Total)
          commit('SET_ROWS', response.Data.Rows)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default company



// WEBPACK FOOTER //
// ./src/store/modules/company.js